module.exports = __webpack_public_path__ + "img/top_logo.e1e5c6b3.png";